import {AttrsSchema} from 'panel';

import {ButtonSize, ButtonTheme, ButtonType} from 'common/components/button/constants';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {BaseButtonAttrs, ButtonBase} from '../base/button';
import {template} from './template';
import css from './index.styl?inline';

interface ButtonJsxProps {
  attrs?: ButtonAttrs;
}

type Attrs = {
  class?: string;
  icon?: string;
  size?: ButtonSize;
  theme?: ButtonTheme;
  type?: ButtonType;
  pressed?: boolean;
};

type ButtonAttrs = BaseButtonAttrs & Attrs;

export class Button extends ButtonBase<Attrs> {
  static get attrsSchema(): AttrsSchema<ButtonAttrs> {
    return {
      ...super.attrsSchema,
      class: `string`,
      icon: `string`,
      size: {type: `string`, enum: Object.values(ButtonSize), default: ButtonSize.Medium},
      theme: {type: `string`, enum: Object.values(ButtonTheme), default: ButtonTheme.Secondary},
      type: {type: `string`, enum: Object.values(ButtonType), default: ButtonType.Info},
      pressed: `boolean`,
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
      helpers: {
        ...super.config.helpers,
        ButtonType,
      },
    });
  }
}

export const ButtonEl = defineAndMakeJsxFactory<ButtonJsxProps>(`mp-button`, Button);
